/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Creator_NameInputs */

const en_pricing_creator_name = /** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const es_pricing_creator_name = /** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador`)
};

const fr_pricing_creator_name = /** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur`)
};

const de_pricing_creator_name = /** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const id_pricing_creator_name = /** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreator`)
};

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const ja_pricing_creator_name = en_pricing_creator_name;

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const zh_pricing_creator_name = en_pricing_creator_name;

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const ar_pricing_creator_name = en_pricing_creator_name;

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const it_pricing_creator_name = en_pricing_creator_name;

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const ru_pricing_creator_name = en_pricing_creator_name;

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const pt_pricing_creator_name = en_pricing_creator_name;

/** @type {(inputs: Pricing_Creator_NameInputs) => LocalizedString} */
const ko_pricing_creator_name = en_pricing_creator_name;

/**
* | output |
* | --- |
* | "Creator" |
*
* @param {Pricing_Creator_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_creator_name = /** @type {((inputs?: Pricing_Creator_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Creator_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_creator_name(inputs)
	if (locale === "es") return es_pricing_creator_name(inputs)
	if (locale === "fr") return fr_pricing_creator_name(inputs)
	if (locale === "de") return de_pricing_creator_name(inputs)
	if (locale === "ja") return ja_pricing_creator_name(inputs)
	if (locale === "zh") return zh_pricing_creator_name(inputs)
	if (locale === "ar") return ar_pricing_creator_name(inputs)
	if (locale === "id") return id_pricing_creator_name(inputs)
	if (locale === "it") return it_pricing_creator_name(inputs)
	if (locale === "ru") return ru_pricing_creator_name(inputs)
	if (locale === "pt") return pt_pricing_creator_name(inputs)
	return ko_pricing_creator_name(inputs)
});